import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
	card: {
		minHeight: "100%",
		//display: "flex",
		flexDirection: "column",
		maxWidth: "100%",
		padding: "0",
	},
	GridContainer: {
		display: "inline-block",
	},
	visitsNumberContainer: {
		// display: "flex",
		alignItems: "center",
		flexGrow: 1,
		paddingBottom: theme.spacing(1),
	},
	progressSection: {
		display: "inline-block",
		flexDirection: "row",
		paddingInlineStart: "1rem",
		marginTop: "14px",
		"&:nth-child(3)": {
			width: "10%",
		},
	},

	name: {
		paddingTop: "0",
	},

	ProgresSectionBar: {
		display: "inline-block",
	},
	RemainingWork: {
		marginTop: "12px",
		color: "white",
		fontSize: "0.7rem",
		marginInlineStart: "1rem",
	},
	progressTitle: {
		marginBottom: theme.spacing(1),
	},
	paper: {
		padding: theme.spacing(2),
		display: "flex",
		overflow: "auto",
		flexDirection: "column",
	},
	fixedHeight: {
		// height: 650,
		minHeight: 500,
		height: "100%",
		[theme.breakpoints.down("xs")]: {
      		minHeight: 460,
    	},
	},
	fullfixedHeight: {
		height: 355,
	},
	rightfixedHeight: {
		//height: 580,
	},
	title: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		// alignItems: "center",
		width: "100%",
		marginBottom: theme.spacing(1),
	},
	select: {
		backgroundColor: "white",
		marginInlineStart: "2rem",
		width: "150px",
		height: "30px",
		color: "black",
		borderRadius: "7%",
		fontSize: "13px",
	},

	selectInput: {
		padding: 10,
		paddingInlineEnd: 25,
		"&:focus": {
			backgroundColor: "white",
		},
	},
	progress: {
		marginBottom: theme.spacing(1),
		backgroundColor: theme.palette.warning.main,
	},
	pieChartLegendWrapper: {
		height: "100%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "flex-end",
		marginInlineEnd: theme.spacing(1),
	},
	legendItemContainer: {
		display: "flex",
		alignItems: "center",
		marginBottom: theme.spacing(1),
	},
	fullHeightBody: {
		display: "flex",
		flexGrow: 1,
		flexDirection: "column",
		justifyContent: "space-between",
	},
	tableWidget: {
		overflowX: "auto",
	},
	progressBar: {
		backgroundColor: theme.palette.success.main,
		color: "green",
	},
	performanceLegendWrapper: {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		marginBottom: theme.spacing(1),
	},
	legendElement: {
		display: "flex",
		alignItems: "center",
		marginInlineEnd: theme.spacing(2),
	},
	legendElementText: {
		marginInlineStart: theme.spacing(1),
		color: "white",
	},
	serverOverviewElement: {
		display: "flex",
		alignItems: "center",
		maxWidth: "100%",
	},
	serverOverviewElementText: {
		minWidth: 145,
		paddingInlineEnd: theme.spacing(2),
	},
	serverOverviewElementChartWrapper: {
		width: "100%",
	},
	mainChartBody: {
		overflowX: "auto",
	},
	mainChartHeader: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		[theme.breakpoints.only("xs")]: {
			flexWrap: "wrap",
		},
	},
	mainChartHeaderLabels: {
		display: "flex",
		alignItems: "center",
		[theme.breakpoints.only("xs")]: {
			order: 3,
			width: "100%",
			justifyContent: "center",
			marginTop: theme.spacing(3),
			marginBottom: theme.spacing(2),
		},
	},
	mainChartHeaderLabel: {
		display: "flex",
		alignItems: "center",
		marginInlineStart: theme.spacing(3),
	},
	mainChartSelectRoot: {
		borderColor: theme.palette.text.hint + "80 !important",
	},
	mainChartSelect: {
		padding: 10,
		paddingInlineEnd: 25,
	},
	mainChartLegentElement: {
		fontSize: "18px !important",
		marginInlineStart: theme.spacing(1),
	},

	Button: {
		display: "flex",
		border: "none",
		color: "blue",
		backgroundColor: "aliceblue",
		verticalAlign: "middle",
		alignItems: "center",
		padding: "0px",
		outline: "none",
	},
	GridStatus: {
		display: "inline-block",
		maxWidth: "100%",
		padding: "0px",
		margin: "0",
	},
	Nodes: {
		display: "flex",
		justifyContent: "space-between",
	},
	LeadInformationGrid: {
		marginTop: "10px",
	},
	EditIcon: {
		justifyContent: "flex-end",
		alignItems: "end",
	},
	LeadInformation: {
		color: "#355CFA",
		marginBottom: -1,
		flex: "1",
		padding: "8px 10px 8px 23px",
		minHeight: 40,
		"&$expanded": {
			minHeight: 40,
		},
	},
	ConferenceButton: {
		// marginInlineStart: "10px",
		color: "blue",
		height: "36px",
		"&:hover": {
			backgroundColor: "#526FEB",
			color: "white",
		},
	},
	rightSideButtons: {
		position: "flex",
		marginInlineStart: "40px",
	},
	DispositionGrid: {
		height: "895px",
		backgroundColor: "white",
		marginTop: "8px",
	},
	DispositionTitle: {
		color: "white",
		backgroundColor: "#242a5a",
		fontSize: "15px",
		lineHeight: "18px",
		marginBottom: -1,
		padding: "16px 25px 16px 24px",
		minHeight: 40,
		"&$expanded": {
			minHeight: 40,
		},
	},
	EditIconDetails: {
		flex: "1",
	},
	MenuListItem: {
		fontSize: "0.8rem",
		paddingInlineStart: "6px",
	},
	CallStatustitle: {
		fontSize: "0.8rem",
	},
	cardBody: {
		textAlign: "center",
	},
	CallNumber: {
		color: "#343A58",
		fontSize: "18px",
		marginTop: "20px",
	},
	caller: {
		fontSize: "12px",
		textAlign: "center",
	},
	CardTitle: {
		display: "flex",
		alignItems: "baseline",
	},
	CallStatusTitle: {
		fontSize: "12px",
		marginInlineStart: "10px",
	},
	AddCallActionArea: {
		textAlign: "center !important",
		marginTop: "30px",
	},
	AddMemberText: {
		color: "#343A58",
		marginTop: "13px",
	},
	AddCallcard: {
		border: "1px solid black",
		borderStyle: "dashed",
		padding: "0",
		maxWidth: "100%",
		minHeight: "100%",
		flexDirection: "column",
	},
	ToggleBar: {
		height: "60px",
		backgroundColor: "#4e80c5",
		display: "flex",
		flexDirection: "column",
	},
	SpeakerButton: {
		marginInlineStart: "10px",
		"&:active": {
			backgroundColor: "#526FEB",
			color: "white",
		},
	},
	ConferenceCallConnect: {
		paddingBottom: "10px",
	},
	ExternalTab: {
		border: "1px solid #526FEB",
		borderRadius: "4px 0px 0px 4px",
		color: "#526FEB",
		backgroundColor: "white",
		fontSize: "14px",
		fontWeight: "600",
		flex: "1 0 32%",
		padding: "0",
		maxWidth: "32%",
		textTransform: "capitalize",
		minWidth: "50%",
		"&:selected": {
			backgroundColor: "#526FEB",
			color: "white",
		},
	},
	InternalTab: {
		border: "1px solid #526FEB",
		// borderRadius:"4px 0px 0px 4px",
		color: "#526FEB",
		backgroundColor: "white",
		fontSize: "14px",
		fontWeight: "600",
		flex: "1 0 32%",
		padding: "0",
		textTransform: "capitalize",
		maxWidth: "32%",
		minWidth: "50%",
		"&:active": {
			backgroundColor: "#526FEB",
			color: "white",
		},
	},
	VDATab: {
		border: "1px solid #526FEB",
		borderRadius: "0px 4px 4px 0px",
		color: "#526FEB",
		backgroundColor: "white",
		fontSize: "14px",
		fontWeight: "600",
		textTransform: "capitalize",
		flex: "1 0 32%",
		padding: "0",
		maxWidth: "32%",
		minWidth: "50%",
		"&:active": {
			backgroundColor: "#526FEB",
			color: "white",
		},
	},
	DialogTitle: {
		fontSize: "18px",
		fontWeight: "600",
		color: "#526FEB",
	},
	NumberText: {
		color: "#343A58",
		fontSize: "14px",
		fontWeight: "600",
		margin: "15px 0px 5px 8px",
	},
	PaperValue: {
		boxShadow: "none",
		padding: "15px 8px",
		flexGrow: 1,
	},
	CallButton: {
		marginTop: "108px",
		marginBottom: "15px",
		textTransform: "capitalize",
		border: "1px solid",
		float: "right",
		width: "88px",
		height: "36px",
		fontSize: "16px",
		color: "#526FEB",
		fontWeight: "600",
	},
	TimeValue: {
		// position: "absolute",
		// paddingTop: "28px",
		marginInlineStart: "1rem",
		color: "white",
	},
	formControl: {
		margin: theme.spacing(1),
		minWidth: 120,
	},
	selectEmpty: {
		borderBottom: "1px solid",
		border: "2px solid",
		borderRadius: "4px",
		height: "30px",
		display: "flex",
		color: "blue",
		backgroundColor: "aliceblue",
		verticalAlign: "middle",
		alignItems: "center",
		padding: "0px",
		outline: "none",
		fontSize: "0.9rem",
		"&:before": {
			borderBottomStyle: "inherit !important",
		},
	},
	textControl: {
		margin: theme.spacing(1),
		width: "285px",
	},
	input: {
		height: "30px",
		padding: "0px",
	},
	menuPaper: {
		maxHeight: "30px",
		//height: '30px',
		padding: "0px",
	},
	CallInfoIconBtn: {
		position: "fixed",
		insetInlineEnd: "0",
		insetBlockEnd: "0",
		color: "#0c82da",
		zIndex: "999",
	},
	CurrCallInfoDiv: {
		[theme.breakpoints.down("md")]: {
      		position: "absolute",
      		zIndex: "1112",
      		width: "50%",
    	},
    	[theme.breakpoints.down("xs")]: {
      		width: "calc(100% - 14px)",
    	},
	},
	MainCallingSection: {
		height: "100%",
	},
}));
